/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { Grid, Tooltip } from '@mui/material';

import { BasicRoutes } from '../../constants/basicRoutes';
import { Namespaces } from '../../i18n';
import { createFooterStyles } from './FooterLayout.styles';

export const FooterLayout = memo(() => {
  const { t } = useTranslation(Namespaces.Navigation);
  const classes = createFooterStyles();

  const currentYear = useMemo(() => new Date().getFullYear(), []);

  return (
    <Grid container className={classes.root}>
      <Tooltip id="git-info" title={`Version: ${SCALEFIELD_APP_VERSION}`}>
        <a
          className={classes.footer_copyright}
          href="https://www.cybertec-postgresql.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('footer.copyright', { currentYear })}
        </a>
      </Tooltip>
      <Grid item>
        <Link to={BasicRoutes.ABOUT} className={classes.footer_menu_link}>
          {t('footer.about')}
        </Link>
        <Link to={BasicRoutes.IMPRINT} target="_blank" className={classes.footer_menu_link}>
          {t('footer.imprint')}
        </Link>
      </Grid>
    </Grid>
  );
});
